import { useState } from 'react';

import type { PrepaidRunEntity } from '@dcc-erp/shared';

import { runRangeLabel } from './pp-helpers';
import { AppModal } from '../AppModal';

export function ReverseRunModal({
  run,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  run: PrepaidRunEntity;
  busy: boolean;
  error: string | null;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}) {
  const [reason, setReason] = useState('');
  return (
    <AppModal
      title={`กลับรายการรอบตัดจ่าย — ${runRangeLabel(run)}`}
      subtitle="ระบบจะออก JV กลับรายการ (Dr ค่าใช้จ่ายจ่ายล่วงหน้า / Cr ค่าใช้จ่าย) ในงวดเปิดถัดไป"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button
            type="button"
            className="btn primary"
            style={{ background: 'var(--warning)' }}
            disabled={busy || !reason.trim()}
            onClick={() => onConfirm(reason)}
          >
            {busy ? 'กำลังกลับรายการ…' : 'ยืนยันกลับรายการ'}
          </button>
        </>
      }
    >
      <label className="meta" style={{ display: 'block', marginBottom: 6 }}>
        เหตุผลในการกลับรายการ *
      </label>
      <textarea
        className="input"
        rows={3}
        value={reason}
        placeholder="เช่น ตัดจ่ายผิดงวด / ผิดสัญญา"
        onChange={(e) => setReason(e.target.value)}
        style={{ width: '100%', resize: 'vertical', padding: 8 }}
      />
      {error && <div style={{ color: 'var(--negative)', fontSize: 14, marginTop: 8 }}>{error}</div>}
    </AppModal>
  );
}
